import React from 'react';
import { Link } from 'react-router-dom';
import { FaStar, FaUserPlus, FaUserCheck } from 'react-icons/fa';
import { Author } from './types';
 
interface PostHeaderProps {
  darkMode: boolean;
  author: Author | undefined;
  createdAt: string;
  isOwnPost: boolean;
  isFollowing: boolean;
  followLoading: boolean;
  onFollow: () => void;
  formatTime: (isoString: string) => string;
}
 
export const PostHeader: React.FC<PostHeaderProps> = ({
  darkMode, author, createdAt, isOwnPost,
  isFollowing, followLoading, onFollow, formatTime,
}) => {
  return (
    <div className="flex items-center gap-3 flex-1 min-w-0">
      <div className="relative">
        <Link to={author?.username ? `/profile/${author.username}` : '#'}>
          <img
            src={author?.avatar_url || 'https://i.pravatar.cc/150'}
            alt={author?.username || 'User'}
            className="w-10 h-10 rounded-full cursor-pointer hover:opacity-80 transition-opacity"
            style={{ border: `2px solid ${darkMode ? 'rgba(90,184,184,0.25)' : 'rgba(13,26,26,0.15)'}` }}
          />
        </Link>
        {author?.isPremium && (
          <div
            className="absolute -bottom-0.5 -right-0.5 w-4 h-4 rounded-full flex items-center justify-center"
            style={{ background: '#e8a820', border: '2px solid #0d1a1a' }}
          >
            <FaStar style={{ color: '#0d1a1a', fontSize: '7px' }} />
          </div>
        )}
      </div>
 
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2">
          <Link
            to={author?.username ? `/profile/${author.username}` : '#'}
            className="text-sm font-black truncate hover:underline transition-all"
            style={{ color: darkMode ? '#f0fafa' : '#0d1a1a', letterSpacing: '0.3px' }}
          >
            {author?.username || 'Anonymous'}
          </Link>
          <span style={{ color: darkMode ? 'rgba(126,206,206,0.25)' : 'rgba(13,26,26,0.25)', fontSize: '10px' }}>•</span>
          <span className="text-xs font-bold" style={{ color: darkMode ? 'rgba(126,206,206,0.4)' : 'rgba(13,26,26,0.4)' }}>
            {formatTime(createdAt)}
          </span>
        </div>
        <span className="text-[10px] font-bold" style={{ color: darkMode ? 'rgba(90,184,184,0.4)' : 'rgba(13,26,26,0.35)', letterSpacing: '0.5px' }}>
          LVL {author?.level || 1}
        </span>
      </div>
 
      {!isOwnPost && (
        <button
          onClick={onFollow}
          disabled={followLoading}
          className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg font-bold text-xs transition-all"
          style={{
            opacity: followLoading ? 0.5 : 1,
            cursor: followLoading ? 'not-allowed' : 'pointer',
            background: isFollowing
              ? darkMode ? 'rgba(90,184,184,0.1)' : 'rgba(13,26,26,0.06)'
              : '#e8a820',
            border: `2px solid ${isFollowing ? (darkMode ? 'rgba(90,184,184,0.2)' : 'rgba(13,26,26,0.15)') : '#0d1a1a'}`,
            boxShadow: isFollowing ? 'none' : '2px 2px 0 #0d1a1a',
            color: isFollowing ? (darkMode ? '#5ab8b8' : '#0d1a1a') : '#0d1a1a',
            letterSpacing: '0.5px',
          }}
        >
          {followLoading ? (
            <div className="w-3 h-3 rounded-full border-2 border-t-transparent animate-spin"
              style={{ borderColor: '#0d1a1a', borderTopColor: 'transparent' }} />
          ) : isFollowing ? (
            <><FaUserCheck style={{ fontSize: '10px' }} /><span>FOLLOWING</span></>
          ) : (
            <><FaUserPlus style={{ fontSize: '10px' }} /><span>FOLLOW</span></>
          )}
        </button>
      )}
    </div>
  );
};